var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{class:[_vm.type == 1 ? 'sy_05ul' : 'sy_06ul']},_vm._l((_vm.companyList),function(item){return _c('a',{key:item.id,attrs:{"href":'enterprise_detail.html?id='+item.id}},[_c('li',[_c('div',{staticClass:"pic",style:({
          backgroundImage: 'url('+item.logo+')',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: 'contain'})}),_c('div',{staticClass:"text"},[_c('div',{staticClass:"tit"},[_vm._v(_vm._s(item.name))]),_c('div',{staticClass:"con"},[_vm._v(_vm._s(item.brief))])])])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }